import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled from "styled-components";
import { Checkbox } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
export var GraphContainer = styled.div.withConfig({
  displayName: "stackedBarchartstyles__GraphContainer",
  componentId: "sc-yudqof-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    width: calc(100% - 400px);\n\n    @media (max-width: ".concat(theme.breakpoints[2], "){\n      width: 100%;\n    }\n");
});
export var StyledCheckbox = styled(function (props) {
  return /*#__PURE__*/_jsx(Checkbox, _objectSpread({}, props));
}).withConfig({
  displayName: "stackedBarchartstyles__StyledCheckbox",
  componentId: "sc-yudqof-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color,
    checked = _ref2.checked;
  return "\n    input {\n      background: ".concat(checked ? color : "", ";\n      color: ").concat(checked ? theme.colors.G1 : "", ";\n    }\n  ");
});